import React, {forwardRef} from 'react';
import {useUiState} from '../../Context/UserInterface/UserInterfaceContext';
import ThreeDPreview from '../../ThreeDPreview/ThreeDPreview';

export interface PreviewPageProps {
  onContinueInEditor?: (pageNumber?: number) => void;
}

const Preview3d = forwardRef(({onContinueInEditor}: PreviewPageProps, fwdRef) => {
  const ui = useUiState();

  return (
    <ThreeDPreview
      isSmallScreen={ui.state.isSmallScreen}
      fullScreen={true}
      floating={false}
      status={ui.state.threeDPreviewStatus}
      showEditButton={false}
      showToggle={false}
    />
  );
});

export default Preview3d;
